import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
import detectBrowserLanguage from "detect-browser-language";

import langEN from "../lang/en";
import langDE from "../lang/de";
import langNO from "../lang/no";
import langHR from "../lang/hr";

const languageDetector = {
  type: "languageDetector",
  async: true, // flags below detection to be async
  // detect: (callback) => { /*Localization.getLocalizationAsync().then(({ locale }) => { callback(locale); }) } */,
  detect: callback => {
    let language = detectBrowserLanguage();

    if (language === "us") {
      language = "en";
    }

    callback(language);
  },
  init: () => {},
  cacheUserLanguage: () => {}
};

i18n
  .use(languageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: "de",

    resources: {
      en: langEN,
      de: langDE,
      no: langNO,
      hr: langHR
    },

    // have a common namespace used around the full app
    ns: ["common"],
    defaultNS: "common",

    debug: false,

    cache: {
      enabled: true
    },

    interpolation: {
      escapeValue: false // not needed for react as it does escape per default to prevent xss!
    }
  });

export default i18n;
